export default class EpisodePageViewAggregation {
  constructor(public formatDate: string, public pageView: number) {}
}
